import * as commonTypes from "../services/radActionType";
import * as radListType from "../radList/services/RADListActionType";
import * as unassignedProviderListType from "../unassignedProviderList/services/unassignedProviderListActionType";
import * as capacityInputType from "../capacityInput/services/CapacityInputActionType";
import * as capacityInputNewType from "../capacityInputNew/services/ProviderCapacityInputActionType";
import * as leaderShipBulkUpdateType from "../leadershipBulkUpdate/services/leadershipBulkUpdateActionType";
import * as auditlogstype from "../auditLogs/AuditlogsServices/AuditlogsActionType";
import * as editradprofiletype from "../editRadProfileDuplicate/EditRadProfileServices/EditRadProfileActionType";
import * as radprofiletype from "../radProfile/services/radActionType";
import * as customViewTypes from "../customView/services/customViewActionType";
import initialState from "../../../store/initialState";
import * as hourlyvolumesharetypes from "../hourlyVolumeShare/services/hourlyVolumeShareActionType";
import * as annualhourtrackertypes from "../annualHourTracker/services/annualHourTrackerActionType";
import * as stateLicenseTypes from "../stateLicense/services/stateLicenseActionType";
import * as licensePrivilegesPowerSyncTypes from "../licensePrivilegesPowerSync/services/licensePrivilegesPowerSyncActionType";

const types = {
  ...commonTypes,
  ...radListType,
  ...unassignedProviderListType,
  ...capacityInputType,
  ...capacityInputNewType,
  ...leaderShipBulkUpdateType,
  ...auditlogstype,
  ...editradprofiletype,
  ...hourlyvolumesharetypes,
  ...annualhourtrackertypes,
  ...stateLicenseTypes,
  ...licensePrivilegesPowerSyncTypes,
  ...radprofiletype,
  ...customViewTypes,
};

const radReducer = (state = initialState.rad, action) => {
  switch (action.type) {
    // Fetch Provider List
    case types.FETCH_RADLIST_REQUEST:
      return { ...state, isRadListLoading: true };

    case types.FETCH_RADLIST_SUCCESS:
      return {
        ...state,
        isRadListLoading: false,
        isCustomView: action.payload?.isCustomView || false,
        fieldName: action.payload?.fieldName || [],
        fieldValues: action.payload?.fieldValues || [],
        radList: action.payload?.listRAD || [],
      };

    case types.FETCH_RADLIST_FAILURE:
      return { ...state, isRadListLoading: false, radList: [] };

    case types.FETCH_UNASSIGNED_PROVIDER_LIST_REQUEST:
      return {
        ...state,
        isUnassignedProviderListLoading: true,
        unassignedProviderListError: null,
      };

    case types.FETCH_UNASSIGNED_PROVIDER_LIST_SUCCESS:
      return {
        ...state,
        isUnassignedProviderListLoading: false,
        unassignedProviderListData: action.payload || [],
        unassignedProviderListError: null,
      };

    case types.FETCH_UNASSIGNED_PROVIDER_LIST_FAILURE:
      return {
        ...state,
        isUnassignedProviderListLoading: false,
        unassignedProviderListData: [],
        unassignedProviderListError: action.payload,
      };

    case types.FETCH_STATE_LICENSE_REQUEST:
      return { ...state, isStateLicenseLoading: true };

    case types.FETCH_STATE_LICENSE_SUCCESS:
      return {
        ...state,
        isStateLicenseLoading: false,
        stateLicenseList: action.payload || [],
      };

    case types.FETCH_STATE_LICENSE_FAILURE:
      return {
        ...state,
        isStateLicenseLoading: false,
        stateLicenseList: [],
      };

    case types.FETCH_STATE_LICENSE_NOTES_REQUEST:
      return { ...state, isStateLicenseNotesLoading: true };

    case types.FETCH_STATE_LICENSE_NOTES_SUCCESS:
      return {
        ...state,
        isStateLicenseNotesLoading: false,
        stateLicenseNotesList: action.payload || [],
      };

    case types.FETCH_STATE_LICENSE_NOTES_FAILURE:
      return {
        ...state,
        isStateLicenseNotesLoading: false,
        stateLicenseNotesList: [],
      };

    case types.ADD_STATE_LICENSE_NOTE_REQUEST:
      return { ...state, isAddStateLicenseNoteLoading: true };

    case types.ADD_STATE_LICENSE_NOTE_SUCCESS: {
      const { noteText, detailsId } = action.payload || {};
      const patchRow = (row) =>
        row.Provider_StateLicenseDetailsId === detailsId
          ? { ...row, LastNote: noteText }
          : row;
      let patchedList = state.stateLicenseList;
      if (Array.isArray(patchedList)) {
        patchedList = patchedList.map(patchRow);
      } else if (Array.isArray(patchedList?.lstStateLicense)) {
        patchedList = { ...patchedList, lstStateLicense: patchedList.lstStateLicense.map(patchRow) };
      } else if (Array.isArray(patchedList?.LstStateLicense)) {
        patchedList = { ...patchedList, LstStateLicense: patchedList.LstStateLicense.map(patchRow) };
      }
      return { ...state, isAddStateLicenseNoteLoading: false, stateLicenseList: patchedList };
    }

    case types.ADD_STATE_LICENSE_NOTE_FAILURE:
      return { ...state, isAddStateLicenseNoteLoading: false };

    case types.CLEAR_STATE_LICENSE_NOTES:
      return {
        ...state,
        stateLicenseNotesList: [],
        isStateLicenseNotesLoading: false,
      };

    // Rad Site Assignment Notes (shared by rad profile + site profile)
    case types.FETCH_RAD_SITE_ASSIGNMENT_NOTES_REQUEST:
      return { ...state, isRadSiteAssignmentNotesLoading: true };

    case types.FETCH_RAD_SITE_ASSIGNMENT_NOTES_SUCCESS:
      return {
        ...state,
        isRadSiteAssignmentNotesLoading: false,
        radSiteAssignmentNotesList: action.payload || [],
      };

    case types.FETCH_RAD_SITE_ASSIGNMENT_NOTES_FAILURE:
      return {
        ...state,
        isRadSiteAssignmentNotesLoading: false,
        radSiteAssignmentNotesList: [],
      };

    case types.FETCH_RAD_SITE_ASSIGNMENT_ALL_NOTES_REQUEST:
      return { ...state, isAllRadSiteAssignmentNotesLoading: true };

    case types.FETCH_RAD_SITE_ASSIGNMENT_ALL_NOTES_SUCCESS:
      return {
        ...state,
        isAllRadSiteAssignmentNotesLoading: false,
        allRadSiteAssignmentNotesList: action.payload || [],
      };

    case types.FETCH_RAD_SITE_ASSIGNMENT_ALL_NOTES_FAILURE:
      return {
        ...state,
        isAllRadSiteAssignmentNotesLoading: false,
        allRadSiteAssignmentNotesList: [],
      };

    case types.ADD_RAD_SITE_ASSIGNMENT_NOTE_REQUEST:
      return { ...state, isAddRadSiteAssignmentNoteLoading: true };

    case types.ADD_RAD_SITE_ASSIGNMENT_NOTE_SUCCESS:
      return {
        ...state,
        isAddRadSiteAssignmentNoteLoading: false,
        addRadSiteAssignmentNoteSuccess: true,
      };

    case types.ADD_RAD_SITE_ASSIGNMENT_NOTE_FAILURE:
      return { ...state, isAddRadSiteAssignmentNoteLoading: false };

    case types.CLEAR_RAD_SITE_ASSIGNMENT_NOTES:
      return {
        ...state,
        radSiteAssignmentNotesList: [],
        isRadSiteAssignmentNotesLoading: false,
      };

    case types.CLEAR_RAD_SITE_ASSIGNMENT_ALL_NOTES:
      return {
        ...state,
        allRadSiteAssignmentNotesList: [],
        isAllRadSiteAssignmentNotesLoading: false,
      };

    case types.RESET_ADD_RAD_SITE_ASSIGNMENT_NOTE_SUCCESS:
      return { ...state, addRadSiteAssignmentNoteSuccess: false };

    // Dropdown Filter
    case types.DROPDOWN_FILTER_REQUEST:
      return { ...state, isRadListLoading: true };
    case types.DROPDOWN_FILTER_SUCCESS:
      return {
        ...state,
        isRadListLoading: false,
        dropdownFilterData: action.payload || [],
      };
    case types.DROPDOWN_FILTER_FAILURE:
      return { ...state, isRadListLoading: false, dropdownFilterData: [] };

    // Fetch Capacity Input
    case types.FETCH_CAPACITY_INPUT_REQUEST:
      return { ...state, isRadListLoading: true };
    case types.FETCH_CAPACITY_INPUT_SUCCESS:
      return {
        ...state,
        isRadListLoading: false,
        capacityInputData: action.payload || [],
      };
    case types.FETCH_CAPACITY_INPUT_FAILURE:
      return { ...state, isRadListLoading: false, capacityInputData: [] };

    // Fetch Capacity Input (New)
    case types.FETCH_CAPACITY_INPUT_NEW_REQUEST:
      return { ...state, isRadListLoading: true };
    case types.FETCH_CAPACITY_INPUT_NEW_SUCCESS:
      return {
        ...state,
        isRadListLoading: false,
        capacityInputDataNew: action.payload || [],
      };
    case types.FETCH_CAPACITY_INPUT_NEW_FAILURE:
      return { ...state, isRadListLoading: false, capacityInputDataNew: [] };

    // Fetch Capacity Filter Masters (New)
    case types.FETCH_CAPACITY_FILTERS_NEW_REQUEST:
      return { ...state };
    case types.FETCH_CAPACITY_FILTERS_NEW_SUCCESS:
      return {
        ...state,
        capacityFilterMasters: action.payload || { ProviderList: [], ProviderTypes: [], WorkLocations: [] },
      };
    case types.FETCH_CAPACITY_FILTERS_NEW_FAILURE:
      return { ...state };

    // Fetch Default Provider Capacity
    case types.FETCH_DEFAULT_RAD_CAPACITY_REQUEST:
      return { ...state, isRadListLoading: true };
    case types.FETCH_DEFAULT_RAD_CAPACITY_SUCCESS:
      return {
        ...state,
        isRadListLoading: false,
        defaultRadCapacity: action.payload || {},
      };
    case types.FETCH_DEFAULT_RAD_CAPACITY_FAILURE:
      return { ...state, isRadListLoading: false, defaultRadCapacity: {} };

    // Fetch Default Provider Capacity (New)
    case types.FETCH_DEFAULT_RAD_CAPACITY_NEW_REQUEST:
      return { ...state, isRadListLoading: true };
    case types.FETCH_DEFAULT_RAD_CAPACITY_NEW_SUCCESS:
      return {
        ...state,
        isRadListLoading: false,
        defaultRadCapacityNew: action.payload || {},
      };
    case types.FETCH_DEFAULT_RAD_CAPACITY_NEW_FAILURE:
      return { ...state, isRadListLoading: false, defaultRadCapacityNew: {} };

    // Update Provider Capacity Input
    case types.UPDATE_RAD_CAPACITY_INPUT_REQUEST:
      return { ...state, isRadListLoading: true };
    case types.UPDATE_RAD_CAPACITY_INPUT_SUCCESS:
      return {
        ...state,
        isRadListLoading: false,
        updatedRadCapacityInput: action.payload || {},
      };
    case types.UPDATE_RAD_CAPACITY_INPUT_FAILURE:
      return { ...state, isRadListLoading: false, updatedRadCapacityInput: {} };

    // Update Provider Capacity Input (New)
    case types.UPDATE_RAD_CAPACITY_INPUT_NEW_REQUEST:
      return { ...state, isRadListLoading: true };
    case types.UPDATE_RAD_CAPACITY_INPUT_NEW_SUCCESS:
      return {
        ...state,
        isRadListLoading: false,
        updatedRadCapacityInputNew: action.payload || {},
      };
    case types.UPDATE_RAD_CAPACITY_INPUT_NEW_FAILURE:
      return {
        ...state,
        isRadListLoading: false,
        updatedRadCapacityInputNew: {},
      };

    // Rad Capacity IP Upload
    case types.RAD_CAPACITY_IP_UPLOAD_REQUEST:
      return { ...state, isRadListLoading: true };
    case types.RAD_CAPACITY_IP_UPLOAD_SUCCESS:
      return {
        ...state,
        isRadListLoading: false,
        radCapacityIpUploadResponse: action.payload || {},
      };
    case types.RAD_CAPACITY_IP_UPLOAD_FAILURE:
      return {
        ...state,
        isRadListLoading: false,
        radCapacityIpUploadResponse: {},
      };

    // Rad Capacity IP Upload (New)
    case types.RAD_CAPACITY_IP_UPLOAD_NEW_REQUEST:
      return { ...state, isRadListLoading: true };
    case types.RAD_CAPACITY_IP_UPLOAD_NEW_SUCCESS:
      return {
        ...state,
        isRadListLoading: false,
        radCapacityIpUploadResponseNew: action.payload || {},
      };
    case types.RAD_CAPACITY_IP_UPLOAD_NEW_FAILURE:
      return {
        ...state,
        isRadListLoading: false,
        radCapacityIpUploadResponseNew: {},
      };

    // Fetch Provider Profile
    case types.FETCH_RADPROFILE_REQUEST:
      return { ...state, isRadProfileLoading: true };

    case types.FETCH_RADPROFILE_SUCCESS:
      return {
        ...state,
        isRadProfileLoading: false,
        radProfile: action.payload || {},
      };

    case types.FETCH_RADPROFILE_FAILURE:
      return { ...state, isRadProfileLoading: false, radProfile: {} };

    // Add Provider Schedule
    case types.ADD_RAD_SCHEDULE_REQUEST:
      return { ...state, isAddRadScheduleLoading: true };

    case types.ADD_RAD_SCHEDULE_SUCCESS:
      return {
        ...state,
        isAddRadScheduleLoading: false,
        radiologistShiftInputDetails: action.payload || {},
      };

    case types.FETCH_RADPROFILE_GETRADIOLOGIST_TASKBYID_FAILURE:
      return { ...state, isRadiologistTaskLoading: false, radiologistTask: {} };

    // Fetch Edit Provider Profile
    case types.FETCH_EDITRAD_PROFILE_REQUEST:
      return { ...state, isEditRadProfileLoading: true };

    case types.FETCH_EDITRAD_PROFILE_SUCCESS:
      return {
        ...state,
        isEditRadProfileLoading: false,
        radiologistData: action.payload?.radiologistData || {},
        dropdownData: action.payload?.dropdownData || {},
        contractSummary: action.payload?.contractSummary?.SummaryText || "",
        contractSummaryID: action.payload?.contractSummary?.ContractId || "",
        editRadProfileError: null,
      };

    case types.FETCH_EDITRAD_PROFILE_FAILURE:
      return {
        ...state,
        isEditRadProfileLoading: false,
        editRadProfileError: action.payload,
        radiologistData: {},
        dropdownData: {},
      };

    // Fetch Provider Contract Documents
    case types.FETCH_EDITRAD_PROFILE_CONTRACT_DOCUMENTS_REQUEST:
      return { ...state, isEditRadProfileLoading: true };
    case types.FETCH_EDITRAD_PROFILE_CONTRACT_DOCUMENTS_SUCCESS:
      return {
        ...state,
        isEditRadProfileLoading: false,
        contractDocBase64Array: action.payload || [],
      };
    case types.FETCH_EDITRAD_PROFILE_CONTRACT_DOCUMENTS_FAILURE:
      return {
        ...state,
        isEditRadProfileLoading: false,
        contractDocBase64Array: [],
      };

    // Fetch Provider Assignments Dropdown
    case types.FETCH_RAD_ASSIGNMENTS_DROPDOWN_REQUEST:
      return {
        ...state,
        isRadAssignmentsDropdownLoading: true,
        radAssignmentsError: null,
      };
    case types.FETCH_RAD_ASSIGNMENTS_DROPDOWN_SUCCESS:
      return {
        ...state,
        isRadAssignmentsDropdownLoading: false,
        radAssignmentsDropdown: action.payload || {},
      };
    case types.FETCH_RAD_ASSIGNMENTS_DROPDOWN_FAILURE:
      return {
        ...state,
        isRadAssignmentsDropdownLoading: false,
        radAssignmentsDropdown: {},
        radAssignmentsError: action.payload,
      };

    // Fetch Provider Assignments Details
    case types.FETCH_RAD_ASSIGNMENTS_DETAILS_REQUEST:
      return {
        ...state,
        isRadAssignmentsDetailsLoading: true,
        radAssignmentsError: null,
      };
    case types.FETCH_RAD_ASSIGNMENTS_DETAILS_SUCCESS:
      return {
        ...state,
        isRadAssignmentsDetailsLoading: false,
        radAssignmentsDetails: action.payload || {},
      };
    case types.FETCH_RAD_ASSIGNMENTS_DETAILS_FAILURE:
      return {
        ...state,
        isRadAssignmentsDetailsLoading: false,
        radAssignmentsDetails: {},
        radAssignmentsError: action.payload,
      };

    // Save Provider Assignments
    case types.SAVE_RAD_ASSIGNMENTS_REQUEST:
      return {
        ...state,
        isSaveRadAssignmentsLoading: true,
        saveRadAssignmentsError: null,
      };
    case types.SAVE_RAD_ASSIGNMENTS_SUCCESS:
      return {
        ...state,
        isSaveRadAssignmentsLoading: false,
        saveRadAssignmentsResult: action.payload,
        saveRadAssignmentsError: null,
      };
    case types.SAVE_RAD_ASSIGNMENTS_FAILURE:
      return {
        ...state,
        isSaveRadAssignmentsLoading: false,
        saveRadAssignmentsResult: null,
        saveRadAssignmentsError: action.payload,
      };

    // Delete Provider Assignment
    case types.DELETE_RAD_ASSIGNMENT_REQUEST:
      return {
        ...state,
        isDeleteRadAssignmentLoading: true,
        deleteRadAssignmentError: null,
      };
    case types.DELETE_RAD_ASSIGNMENT_SUCCESS:
      return {
        ...state,
        isDeleteRadAssignmentLoading: false,
        deleteRadAssignmentResult: action.payload,
      };
    case types.DELETE_RAD_ASSIGNMENT_FAILURE:
      return {
        ...state,
        isDeleteRadAssignmentLoading: false,
        deleteRadAssignmentError: action.payload,
      };

    // Fetch Week Rotation Template by ID
    case types.FETCH_WEEK_ROTATION_TEMPLATE_BY_ID_REQUEST_RADPROFILE:
      return {
        ...state,
        isWeekRotationTemplateLoading: true,
        weekRotationTemplateError: null,
      };

    case types.FETCH_WEEK_ROTATION_TEMPLATE_BY_ID_SUCCESS_RADPROFILE:
      return {
        ...state,
        isWeekRotationTemplateLoading: false,
        weekRotationTemplateData: action.payload,
        weekRotationTemplateError: null,
      };

    case types.FETCH_WEEK_ROTATION_TEMPLATE_BY_ID_FAILURE_RADPROFILE:
      return {
        ...state,
        isWeekRotationTemplateLoading: false,
        weekRotationTemplateError: action.payload,
        weekRotationTemplateData: null,
      };

    case types.CLEAR_WEEK_ROTATION_TEMPLATE_DATA_RADPROFILE:
      return {
        ...state,
        isWeekRotationTemplateLoading: false,
        weekRotationTemplateData: null,
        weekRotationTemplateError: null,
      };

    // Save Schedule Week Rotation
    case types.SAVE_SCHEDULE_WEEK_ROTATION_REQUEST:
      return {
        ...state,
        isSaveScheduleWeekRotationLoading: true,
        saveScheduleWeekRotationError: null,
      };

    case types.SAVE_SCHEDULE_WEEK_ROTATION_SUCCESS:
      return {
        ...state,
        isSaveScheduleWeekRotationLoading: false,
        saveScheduleWeekRotationResult: action.payload,
        saveScheduleWeekRotationError: null,
      };

    case types.SAVE_SCHEDULE_WEEK_ROTATION_FAILURE:
      return {
        ...state,
        isSaveScheduleWeekRotationLoading: false,
        saveScheduleWeekRotationError: action.payload,
        saveScheduleWeekRotationResult: null,
      };

    case types.ADD_RAD_SCHEDULE_FAILURE:
      return {
        ...state,
        isAddRadScheduleLoading: false,
        radiologistShiftInputDetails: {},
      };
    // Save Rad Schedule
    case types.SAVE_RAD_SCHEDULE_REQUEST:
      return {
        ...state,
        isSaveRadScheduleLoading: true,
        saveRadScheduleError: null,
      };

    case types.SAVE_RAD_SCHEDULE_SUCCESS:
      return {
        ...state,
        isSaveRadScheduleLoading: false,
        radiologistShiftInputDetails: action.payload || {},
        saveRadScheduleError: null,
      };

    case types.SAVE_RAD_SCHEDULE_FAILURE:
      return {
        ...state,
        isSaveRadScheduleLoading: false,
        radiologistShiftInputDetails: {},
        saveRadScheduleError: action.payload || null,
      };

    // Fetch Radiologist Tasks By Date
    case types.FETCH_RADPROFILE_GETRADIOLOGIST_TASKSBYDATE_REQUEST:
      return { ...state, isRadProfileLoading: true };
    case types.FETCH_RADPROFILE_GETRADIOLOGIST_TASKSBYDATE_SUCCESS:
      return {
        ...state,
        isRadProfileLoading: false,
        radiologistTasksByDate: action.payload || [],
      };
    case types.FETCH_RADPROFILE_GETRADIOLOGIST_TASKSBYDATE_FAILURE:
      return {
        ...state,
        isRadProfileLoading: false,
        radiologistTasksByDate: [],
      };

    // Rad Profile Associated Site Matrics
    case types.FETCH_RADPROFILE_ASSOCIATED_SITEMATRICS_REQUEST:
      return {
        ...state,
        isRadProfileLoading: true,
        isAssociatedSiteMetricsLoading: true,
      };
    case types.FETCH_RADPROFILE_ASSOCIATED_SITEMATRICS_SUCCESS:
      return {
        ...state,
        isRadProfileLoading: false,
        isAssociatedSiteMetricsLoading: false,
        radProfileAssociatedSiteMatrics: action.payload?.SiteMatrixDetailsData,
      };
    case types.FETCH_RADPROFILE_ASSOCIATED_SITEMATRICS_FAILURE:
      return {
        ...state,
        isRadProfileLoading: false,
        isAssociatedSiteMetricsLoading: false,
        radProfileAssociatedSiteMatrics: [],
      };
    // Rad Site Matrix Dropdown

    case types.FETCH_RAD_SITE_MATRIX_DROPDOWN_REQUEST:
      return {
        ...state,
        isRadSiteMatrixDropdownLoading: true,
        isAssociatedSiteMetricsLoading: true,
      };
    case types.FETCH_RAD_SITE_MATRIX_DROPDOWN_SUCCESS:
      return {
        ...state,
        isRadSiteMatrixDropdownLoading: false,
        siteDDList: action.payload?.siteDDList || [],
        priorityDDList: action.payload?.priorityDDList || [],
        modalityDDList: action.payload?.modalityDDList || [],
        siteStatusDDList: action.payload?.siteStatusDDList || [],
        radStatusDDList: action.payload?.radStatusDDList || [],
        radSiteMatrixDropdown: action.payload || [],
      };
    case types.FETCH_RAD_SITE_MATRIX_DROPDOWN_FAILURE:
      return {
        ...state,
        isRadSiteMatrixDropdownLoading: false,
        isAssociatedSiteMetricsLoading: false,
        siteDDList: [],
        priorityDDList: [],
        modalityDDList: [],
        siteStatusDDList: [],
        radStatusDDList: [],
        radSiteMatrixDropdown: [],
      };

    // Rad Profile Get Site Metrics Child Table

    case types.FETCH_RADPROFILE_GETSITEMETRICSCHILDTABLE_REQUEST:
      return { ...state, isRadProfileLoading: true };
    case types.FETCH_RADPROFILE_GETSITEMETRICSCHILDTABLE_SUCCESS:
      return {
        ...state,
        isRadProfileLoading: false,
        radProfileGetSiteMetricsChildTable: action.payload || [],
      };

    case types.FETCH_RADPROFILE_GETSITEMETRICSCHILDTABLE_FAILURE:
      return {
        ...state,
        isRadProfileGetSiteMetricsChildTableLoading: false,
        radProfileGetSiteMetricsChildTable: [],
      };

    //GetRadiologist YTD By ID
    case types.FETCH_RADPROFILE_GETRADIOLOGIST_YTDBYID_REQUEST:
      return { ...state, isRadiologistYTDByIDLoading: true };
    case types.FETCH_RADPROFILE_GETRADIOLOGIST_YTDBYID_SUCCESS:
      return {
        ...state,
        isRadiologistYTDByIDLoading: false,
        radiologistYTDByID: action.payload || [],
      };
    case types.FETCH_RADPROFILE_GETRADIOLOGIST_YTDBYID_FAILURE:
      return {
        ...state,
        isRadiologistYTDByIDLoading: false,
        radiologistYTDByID: [],
      };

    //dropdown bindings in the Update Schedule Information
    case types.FETCH_RAD_DROPDOWN_TASKS_REQUEST:
      return { ...state, isRadScheduleDropdownLoading: true };

    case types.FETCH_RAD_DROPDOWN_TASKS_SUCCESS:
      console.log("Dropdown Data:", action.payload); // Debug the payload here
      return {
        ...state,
        isRadScheduleDropdownLoading: false,
        radScheduleDropdown: action.payload || [],
      };

    case types.FETCH_RAD_DROPDOWN_TASKS_FAILURE:
      return {
        ...state,
        isRadScheduleDropdownLoading: false,
        radScheduleDropdown: [],
      };

    // Delete Shift Input Details
    case types.DELETE_SHIFT_INPUT_DETAILS_REQUEST:
      return { ...state, isDeleteShiftInputDetailsLoading: true };

    case types.DELETE_SHIFT_INPUT_DETAILS_SUCCESS:
      return {
        ...state,
        isDeleteShiftInputDetailsLoading: false,
        deleteShiftInputDetailsResponse: action.payload || {},
      };

    case types.DELETE_SHIFT_INPUT_DETAILS_FAILURE:
      return {
        ...state,
        isDeleteShiftInputDetailsLoading: false,
        deleteShiftInputDetailsResponse: {},
      };

    // Fetch Schedules By Date Range
    case types.FETCH_SCHEDULES_BY_DATE_RANGE_REQUEST:
      return { ...state, isRadProfileLoading: true };

    case types.FETCH_SCHEDULES_BY_DATE_RANGE_SUCCESS:
      return {
        ...state,
        isRadProfileLoading: false,
        radiologistTasksByDate: action.payload || [],
      };

    case types.FETCH_SCHEDULES_BY_DATE_RANGE_FAILURE:
      return {
        ...state,
        isRadProfileLoading: false,
        radiologistTasksByDate: [],
      };

    // Fetch Provider Leadership - start
    case types.FETCH_RAD_LEADERSHIP_REQUEST:
      return { ...state, isRadLeadershipLoading: true };
    case types.FETCH_RAD_LEADERSHIP_SUCCESS:
      return {
        ...state,
        isRadLeadershipLoading: false,
        RadLeadership: action.payload.radReportDataList || action.payload || [],
        PracticeDirectorDetailsList:
          action.payload.practiceDirectorDDList || [],
        PracticeManagerDetailsList: action.payload.practiceManagerDDList || [],
        PhysicianLiaisonDetailsList:
          action.payload.physicianLiaisonDDList || [],
        QADirectorDetailsList: action.payload.qaDirectorDDList || [],
        RadSectionChiefDetailsList: action.payload.radSectionChiefDDList || [],
        SectionChiefAssistantDetailsList:
          action.payload.sectionChiefAssistantDDList || [],
      };
    case types.FETCH_RAD_LEADERSHIP_FAILURE:
      return {
        ...state,
        isRadLeadershipLoading: false,
        RadLeadership: [],
        PracticeDirectorDetailsList: [],
        PracticeManagerDetailsList: [],
        PhysicianLiaisonDetailsList: [],
        QADirectorDetailsList: [],
        RadSectionChiefDetailsList: [],
        SectionChiefAssistantDetailsList: [],
      };

    case types.RAD_LEADERSHIP_BULK_UPDATE_REQUEST:
      return { ...state, isRadLeadershipLoading: true };
    case types.RAD_LEADERSHIP_BULK_UPDATE_SUCCESS:
      return { ...state, isRadLeadershipLoading: false };
    case types.RAD_LEADERSHIP_BULK_UPDATE_FAILURE:
      return { ...state, isRadLeadershipLoading: false };

    case types.CHECK_RAD_LEADERSHIP_EDIT_ACCESS_REQUEST:
      return { ...state, isCheckingEditAccess: true };
    case types.CHECK_RAD_LEADERSHIP_EDIT_ACCESS_SUCCESS:
      return {
        ...state,
        isCheckingEditAccess: false,
        canEditRadLeadership: true,
      };
    case types.CHECK_RAD_LEADERSHIP_EDIT_ACCESS_FAILURE:
      return {
        ...state,
        isCheckingEditAccess: false,
        canEditRadLeadership: false,
      };

    case types.DELETE_RAD_LEADERSHIP_BULK_UPDATE_USER_REQUEST:
      return { ...state, isDeletingUserSession: true };
    case types.DELETE_RAD_LEADERSHIP_BULK_UPDATE_USER_SUCCESS:
      return { ...state, isDeletingUserSession: false };
    case types.DELETE_RAD_LEADERSHIP_BULK_UPDATE_USER_FAILURE:
      return { ...state, isDeletingUserSession: false };

    case types.RESET_RAD_LEADERSHIP_EDIT_ACCESS:
      return {
        ...state,
        canEditRadLeadership: null,
        isCheckingEditAccess: false,
      };
    // Fetch Provider Leadership - end

    //Annual Hour Tracker - start
    case types.FETCH_ANNUAL_HOUR_TRACKER_REQUEST:
      return { ...state, isAnnualHourTrackerLoading: true };
    case types.FETCH_ANNUAL_HOUR_TRACKER_SUCCESS:
      return {
        ...state,
        isAnnualHourTrackerLoading: false,
        annualHourTracker: action.payload || {},
      };
    case types.FETCH_ANNUAL_HOUR_TRACKER_FAILURE:
      return {
        ...state,
        isAnnualHourTrackerLoading: false,
        annualHourTracker: {},
      };

    case types.FETCH_ANNUAL_HOUR_TRACKER_DROPDOWN_REQUEST:
      return { ...state, isAnnualHourTrackerLoading: true };
    case types.FETCH_ANNUAL_HOUR_TRACKER_DROPDOWN_SUCCESS:
      return {
        ...state,
        isAnnualHourTrackerLoading: false,
        annualHourTrackerDropdowns: action.payload || {
          RadiologistDropdownItems: [],
          RadStatusDropdownItems: [],
          RadTypeDropdownItems: [],
          WeekRotationDropdownItems: [],
          RPCEDropdownItems: [],
          ScheduleTypeDropdownItems: [],
          SectionDropdownItems: [],
          SubSpecialityDropdownItems: [],
          DayDropdownItems: [],
        },
      };
    case types.FETCH_ANNUAL_HOUR_TRACKER_DROPDOWN_FAILURE:
      return {
        ...state,
        isAnnualHourTrackerLoading: false,
        annualHourTrackerDropdowns: {
          RadiologistDropdownItems: [],
          RadStatusDropdownItems: [],
          RadTypeDropdownItems: [],
          WeekRotationDropdownItems: [],
          RPCEDropdownItems: [],
          ScheduleTypeDropdownItems: [],
          SectionDropdownItems: [],
          SubSpecialityDropdownItems: [],
          DayDropdownItems: [],
        },
      };

    case types.FETCH_ANNUAL_WORKLIST_BY_RPCE_REQUEST:
      return { ...state, isrpceloading: true };
    case types.FETCH_ANNUAL_WORKLIST_BY_RPCE_SUCCESS:
      return {
        ...state,
        isrpceloading: false,
        WorklistDropdownItems: action.payload || [],
      };
    case types.FETCH_ANNUAL_WORKLIST_BY_RPCE_FAILURE:
      return {
        ...state,
        isrpceloading: false,
        WorklistDropdownItems: [],
      };

    case types.FETCH_TASK_BY_WORKLIST_REQUEST:
      return { ...state, isrpceloading: true };
    case types.FETCH_TASK_BY_WORKLIST_SUCCESS:
      return {
        ...state,
        isrpceloading: false,
        TaskDropdownItems: action.payload || [],
      };
    case types.FETCH_TASK_BY_WORKLIST_FAILURE:
      return {
        ...state,
        isrpceloading: false,
        TaskDropdownItems: [],
      };
    case types.EXPORT_TO_CSV_REQUEST_ANNUAL_HOUR_TRACKER:
      return {
        ...state,
        isAnnualHourTrackerLoading: true,
        exportResult: action.payload,
      };

    case types.EXPORT_TO_CSV_SUCCESS_ANNUAL_HOUR_TRACKER:
      return {
        ...state,
        isAnnualHourTrackerLoading: false,
        exportResult: action.payload,
      };
    case types.EXPORT_TO_CSV_FAILURE_ANNUAL_HOUR_TRACKER:
      return {
        ...state,
        isAnnualHourTrackerLoading: false,
        exportError: action.payload,
      };

    case types.REFRESH_ANNUAL_HOUR_TRACKER_REQUEST:
      return { ...state, isAnnualHourTrackerLoading: true };
    case types.REFRESH_ANNUAL_HOUR_TRACKER_SUCCESS:
      return { ...state, isAnnualHourTrackerLoading: false };
    case types.REFRESH_ANNUAL_HOUR_TRACKER_FAILURE:
      return { ...state, isAnnualHourTrackerLoading: false };
    //Annual Hour Tracker - end

    // Rad Hourly Volume Share - start
    case types.FETCH_RAD_HOURLY_VOLUME_SHARE_UN_READ_DETAILS_REQUEST:
      return {
        ...state,
        radHourlyVolumeSharePendingRequests:
          (state.radHourlyVolumeSharePendingRequests || 0) + 1,
        isRadHourlyVolumeShareLoading: true,
      };
    case types.FETCH_RAD_HOURLY_VOLUME_SHARE_UN_READ_DETAILS_SUCCESS:
      return {
        ...state,
        radHourlyVolumeShareUnreadDetails: action.payload || [],
        radHourlyVolumeSharePendingRequests: Math.max(
          (state.radHourlyVolumeSharePendingRequests || 0) - 1,
          0,
        ),
        isRadHourlyVolumeShareLoading:
          Math.max((state.radHourlyVolumeSharePendingRequests || 0) - 1, 0) > 0,
      };
    case types.FETCH_RAD_HOURLY_VOLUME_SHARE_UN_READ_DETAILS_FAILURE:
      return {
        ...state,
        radHourlyVolumeShareUnreadDetails: [],
        radHourlyVolumeSharePendingRequests: Math.max(
          (state.radHourlyVolumeSharePendingRequests || 0) - 1,
          0,
        ),
        isRadHourlyVolumeShareLoading:
          Math.max((state.radHourlyVolumeSharePendingRequests || 0) - 1, 0) > 0,
      };

    case types.FETCH_RAD_HOURLY_VOLUME_SHARE_READ_DETAILS_REQUEST:
      return {
        ...state,
        radHourlyVolumeSharePendingRequests:
          (state.radHourlyVolumeSharePendingRequests || 0) + 1,
        isRadHourlyVolumeShareLoading: true,
      };
    case types.FETCH_RAD_HOURLY_VOLUME_SHARE_READ_DETAILS_SUCCESS:
      return {
        ...state,
        radHourlyVolumeShareReadDetails: action.payload || [],
        radHourlyVolumeSharePendingRequests: Math.max(
          (state.radHourlyVolumeSharePendingRequests || 0) - 1,
          0,
        ),
        isRadHourlyVolumeShareLoading:
          Math.max((state.radHourlyVolumeSharePendingRequests || 0) - 1, 0) > 0,
      };
    case types.FETCH_RAD_HOURLY_VOLUME_SHARE_READ_DETAILS_FAILURE:
      return {
        ...state,
        radHourlyVolumeShareReadDetails: [],
        radHourlyVolumeSharePendingRequests: Math.max(
          (state.radHourlyVolumeSharePendingRequests || 0) - 1,
          0,
        ),
        isRadHourlyVolumeShareLoading:
          Math.max((state.radHourlyVolumeSharePendingRequests || 0) - 1, 0) > 0,
      };

    case types.GET_DORPDOWN_RAD_SITES_REQUEST:
      return {
        ...state,
        radHourlyVolumeSharePendingRequests:
          (state.radHourlyVolumeSharePendingRequests || 0) + 1,
        isRadHourlyVolumeShareLoading: true,
      };
    case types.GET_DORPDOWN_RAD_SITES_SUCCESS:
      return {
        ...state,
        dropdownRadSites: action.payload || [],
        radHourlyVolumeSharePendingRequests: Math.max(
          (state.radHourlyVolumeSharePendingRequests || 0) - 1,
          0,
        ),
        isRadHourlyVolumeShareLoading:
          Math.max((state.radHourlyVolumeSharePendingRequests || 0) - 1, 0) > 0,
      };
    case types.GET_DORPDOWN_RAD_SITES_FAILURE:
      return {
        ...state,
        dropdownRadSites: [],
        radHourlyVolumeSharePendingRequests: Math.max(
          (state.radHourlyVolumeSharePendingRequests || 0) - 1,
          0,
        ),
        isRadHourlyVolumeShareLoading:
          Math.max((state.radHourlyVolumeSharePendingRequests || 0) - 1, 0) > 0,
      };

    case types.GET_WORKLIST_BY_RPCE_ID_REQUEST:
      return {
        ...state,
        radHourlyVolumeSharePendingRequests:
          (state.radHourlyVolumeSharePendingRequests || 0) + 1,
        isRadHourlyVolumeShareLoading: true,
      };
    case types.GET_WORKLIST_BY_RPCE_ID_SUCCESS:
      return {
        ...state,
        worklistByRpceId: action.payload || [],
        radHourlyVolumeSharePendingRequests: Math.max(
          (state.radHourlyVolumeSharePendingRequests || 0) - 1,
          0,
        ),
        isRadHourlyVolumeShareLoading:
          Math.max((state.radHourlyVolumeSharePendingRequests || 0) - 1, 0) > 0,
      };
    case types.GET_WORKLIST_BY_RPCE_ID_FAILURE:
      return {
        ...state,
        worklistByRpceId: [],
        radHourlyVolumeSharePendingRequests: Math.max(
          (state.radHourlyVolumeSharePendingRequests || 0) - 1,
          0,
        ),
        isRadHourlyVolumeShareLoading:
          Math.max((state.radHourlyVolumeSharePendingRequests || 0) - 1, 0) > 0,
      };

    case types.GET_PRATICES_BY_WORKLIST_ID_REQUEST:
      return {
        ...state,
        radHourlyVolumeSharePendingRequests:
          (state.radHourlyVolumeSharePendingRequests || 0) + 1,
        isRadHourlyVolumeShareLoading: true,
      };
    case types.GET_PRATICES_BY_WORKLIST_ID_SUCCESS:
      return {
        ...state,
        praticesByWorklistId: action.payload || [],
        radHourlyVolumeSharePendingRequests: Math.max(
          (state.radHourlyVolumeSharePendingRequests || 0) - 1,
          0,
        ),
        isRadHourlyVolumeShareLoading:
          Math.max((state.radHourlyVolumeSharePendingRequests || 0) - 1, 0) > 0,
      };
    case types.GET_PRATICES_BY_WORKLIST_ID_FAILURE:
      return {
        ...state,
        praticesByWorklistId: [],
        radHourlyVolumeSharePendingRequests: Math.max(
          (state.radHourlyVolumeSharePendingRequests || 0) - 1,
          0,
        ),
        isRadHourlyVolumeShareLoading:
          Math.max((state.radHourlyVolumeSharePendingRequests || 0) - 1, 0) > 0,
      };

    case types.GET_SUB_PRATICES_BY_PRATICE_ID_REQUEST:
      return {
        ...state,
        radHourlyVolumeSharePendingRequests:
          (state.radHourlyVolumeSharePendingRequests || 0) + 1,
        isRadHourlyVolumeShareLoading: true,
      };
    case types.GET_SUB_PRATICES_BY_PRATICE_ID_SUCCESS:
      return {
        ...state,
        subPraticesByPraticeId: action.payload || [],
        radHourlyVolumeSharePendingRequests: Math.max(
          (state.radHourlyVolumeSharePendingRequests || 0) - 1,
          0,
        ),
        isRadHourlyVolumeShareLoading:
          Math.max((state.radHourlyVolumeSharePendingRequests || 0) - 1, 0) > 0,
      };
    case types.GET_SUB_PRATICES_BY_PRATICE_ID_FAILURE:
      return {
        ...state,
        subPraticesByPraticeId: [],
        radHourlyVolumeSharePendingRequests: Math.max(
          (state.radHourlyVolumeSharePendingRequests || 0) - 1,
          0,
        ),
        isRadHourlyVolumeShareLoading:
          Math.max((state.radHourlyVolumeSharePendingRequests || 0) - 1, 0) > 0,
      };

    case types.GET_SITE_BY_SUB_PRATICE_ID_REQUEST:
      return {
        ...state,
        radHourlyVolumeSharePendingRequests:
          (state.radHourlyVolumeSharePendingRequests || 0) + 1,
        isRadHourlyVolumeShareLoading: true,
      };
    case types.GET_SITE_BY_SUB_PRATICE_ID_SUCCESS:
      return {
        ...state,
        siteBySubPraticeId: action.payload || [],
        radHourlyVolumeSharePendingRequests: Math.max(
          (state.radHourlyVolumeSharePendingRequests || 0) - 1,
          0,
        ),
        isRadHourlyVolumeShareLoading:
          Math.max((state.radHourlyVolumeSharePendingRequests || 0) - 1, 0) > 0,
      };
    case types.GET_SITE_BY_SUB_PRATICE_ID_FAILURE:
      return {
        ...state,
        siteBySubPraticeId: [],
        radHourlyVolumeSharePendingRequests: Math.max(
          (state.radHourlyVolumeSharePendingRequests || 0) - 1,
          0,
        ),
        isRadHourlyVolumeShareLoading:
          Math.max((state.radHourlyVolumeSharePendingRequests || 0) - 1, 0) > 0,
      };

    case types.EXPORT_RAD_HOURLY_VOLUME_SHARE_REQUEST:
      return { ...state, isRadHourlyExportLoading: true };
    case types.EXPORT_RAD_HOURLY_VOLUME_SHARE_SUCCESS:
      return { ...state, isRadHourlyExportLoading: false };
    case types.EXPORT_RAD_HOURLY_VOLUME_SHARE_FAILURE:
      return { ...state, isRadHourlyExportLoading: false };
    // Rad Hourly Volume Share - end

    //common cases
    case types.UPDATE_RAD_REDUCER:
      return { ...state, ...action.payload };

    // Provider Profile Provider Metrics -chart- start
    case types.GETRADIOLOGIST_PROFILE_CHART_DETAILS_REQUEST:
      return { ...state, isRadListLoading: true };
    case types.GETRADIOLOGIST_PROFILE_CHART_DETAILS_SUCCESS:
      return {
        ...state,
        isRadListLoading: false,
        radMetricsData: action.payload || {},
      };
    case types.GETRADIOLOGIST_PROFILE_CHART_DETAILS_FAILURE:
      return { ...state, isRadListLoading: false, radMetricsData: {} };
    // Provider Profile Provider Metrics -chart- end

    // Provider Metrics Dropdown
    case types.FETCH_RAD_PROVIDER_METRICS_DROPDOWN_REQUEST:
      return { ...state, isProviderMetricsDropdownLoading: true };
    case types.FETCH_RAD_PROVIDER_METRICS_DROPDOWN_SUCCESS:
      return {
        ...state,
        isProviderMetricsDropdownLoading: false,
        providerMetricsPriorityBucketDDList: action.payload?.priorityBucketDDList || [],
        providerMetricsPriorityDDList: action.payload?.priorityDDList || [],
        providerMetricsModalityDDList: action.payload?.modalityDDList || [],
        providerMetricsSubSpecialityDDList: action.payload?.subSpecialityDDList || [],
        providerMetricsWorkLocationDDList: action.payload?.workLocationDDList || [],
      };
    case types.FETCH_RAD_PROVIDER_METRICS_DROPDOWN_FAILURE:
      return {
        ...state,
        isProviderMetricsDropdownLoading: false,
        providerMetricsPriorityBucketDDList: [],
        providerMetricsPriorityDDList: [],
        providerMetricsModalityDDList: [],
        providerMetricsSubSpecialityDDList: [],
        providerMetricsWorkLocationDDList: [],
      };

    // Provider Metrics Chart Details (with filters)
    case types.FETCH_RAD_PROVIDER_METRICS_CHART_DETAILS_REQUEST:
      return { ...state, isRadListLoading: true };
    case types.FETCH_RAD_PROVIDER_METRICS_CHART_DETAILS_SUCCESS:
      return {
        ...state,
        isRadListLoading: false,
        radMetricsData: action.payload || {},
      };
    case types.FETCH_RAD_PROVIDER_METRICS_CHART_DETAILS_FAILURE:
      return { ...state, isRadListLoading: false, radMetricsData: {} };

    // Custom View - start
    case types.GET_ALL_CUSTOM_VIEWS_REQUEST:
      return { ...state, isCustomViewLoading: true };
    case types.GET_ALL_CUSTOM_VIEWS_SUCCESS:
      return {
        ...state,
        isCustomViewLoading: false,
        customViews: action.payload || [],
      };
    case types.GET_ALL_CUSTOM_VIEWS_FAILURE:
      return { ...state, isCustomViewLoading: false };

    case types.GET_CUSTOM_VIEW_FIELDS_REQUEST:
      return { ...state, isCustomViewLoading: true };
    case types.GET_CUSTOM_VIEW_FIELDS_SUCCESS:
      return {
        ...state,
        isCustomViewLoading: false,
        customViewFields: action.payload || [],
      };
    case types.GET_CUSTOM_VIEW_FIELDS_FAILURE:
      return { ...state, isCustomViewLoading: false };

    case types.SAVE_CUSTOM_VIEW_FIELDS_REQUEST:
      return { ...state, isCustomViewLoading: true };
    case types.SAVE_CUSTOM_VIEW_FIELDS_SUCCESS:
      return { ...state, isCustomViewLoading: false };
    case types.SAVE_CUSTOM_VIEW_FIELDS_FAILURE:
      return { ...state, isCustomViewLoading: false };
    //-------------------------------------------------------------------------------------------------------------------------------------------//
    // Fetch New Custom Views List
    case customViewTypes.FETCH_CUSTOM_VIEWS_REQUEST:
      return { ...state, isFetchingCustomViews: true, customViewsError: null };
    case customViewTypes.FETCH_CUSTOM_VIEWS_SUCCESS:
      return {
        ...state,
        isFetchingCustomViews: false,
        customViewsData:
          action.payload?.values?.lstRadiologistCustomViews || [],
        customViewsError: null,
      };
    case customViewTypes.FETCH_CUSTOM_VIEWS_FAILURE:
      return {
        ...state,
        isFetchingCustomViews: false,
        customViewsError: action.payload,
        customViewsData: [],
      };

    case customViewTypes.TOGGLE_CUSTOM_VIEW_STATUS_REQUEST:
      return {
        ...state,
        isTogglingCustomViewStatus: true,
        toggleCustomViewStatusError: null,
      };
    case customViewTypes.TOGGLE_CUSTOM_VIEW_STATUS_SUCCESS:
      return {
        ...state,
        isTogglingCustomViewStatus: false,
        toggleCustomViewStatusError: null,
      };
    case customViewTypes.TOGGLE_CUSTOM_VIEW_STATUS_FAILURE:
      return {
        ...state,
        isTogglingCustomViewStatus: false,
        toggleCustomViewStatusError: action.payload,
      };

    case customViewTypes.DELETE_CUSTOM_VIEW_REQUEST:
      return {
        ...state,
        isDeletingCustomView: true,
        deleteCustomViewError: null,
      };
    case customViewTypes.DELETE_CUSTOM_VIEW_SUCCESS:
      return {
        ...state,
        isDeletingCustomView: false,
        deleteCustomViewError: null,
      };
    case customViewTypes.DELETE_CUSTOM_VIEW_FAILURE:
      return {
        ...state,
        isDeletingCustomView: false,
        deleteCustomViewError: action.payload,
      };

    case customViewTypes.FETCH_RAD_CUSTOM_VIEW_REQUEST:
      return {
        ...state,
        isFetchingRadCustomView: true,
        radCustomViewError: null,
      };
    case customViewTypes.FETCH_RAD_CUSTOM_VIEW_SUCCESS:
      return {
        ...state,
        isFetchingRadCustomView: false,
        radCustomViewData: action.payload?.fieldValues || [],
        radCustomViewColumns: action.payload?.fieldName || [],
        radCustomViewError: null,
      };
    case customViewTypes.FETCH_RAD_CUSTOM_VIEW_FAILURE:
      return {
        ...state,
        isFetchingRadCustomView: false,
        radCustomViewError: action.payload,
        radCustomViewData: [],
        radCustomViewColumns: [],
      };

    // Fetch Custom View Share Dropdown and table in AddRadCustomViewModal
    case customViewTypes.FETCH_CUSTOM_VIEW_SHARE_DROPDOWN_REQUEST:
      return {
        ...state,
        isFetchingCustomViewShareDropdown: true,
        customViewShareDropdownError: null,
      };
    case customViewTypes.FETCH_CUSTOM_VIEW_SHARE_DROPDOWN_SUCCESS:
      return {
        ...state,
        isFetchingCustomViewShareDropdown: false,
        customViewShareDropdown: action.payload?.dropdownData || [],
        customViewSharedList: action.payload?.sharedListData || [],
        customViewShareDropdownError: null,
      };
    case customViewTypes.FETCH_CUSTOM_VIEW_SHARE_DROPDOWN_FAILURE:
      return {
        ...state,
        isFetchingCustomViewShareDropdown: false,
        customViewShareDropdownError: action.payload,
        customViewShareDropdown: [],
      };

    // Save Shared Custom View
    case customViewTypes.SAVE_SHARED_CUSTOM_VIEW_REQUEST:
      return {
        ...state,
        isSavingSharedCustomView: true,
        saveSharedCustomViewError: null,
      };
    case customViewTypes.SAVE_SHARED_CUSTOM_VIEW_SUCCESS:
      return {
        ...state,
        isSavingSharedCustomView: false,
        saveSharedCustomViewError: null,
      };
    case customViewTypes.SAVE_SHARED_CUSTOM_VIEW_FAILURE:
      return {
        ...state,
        isSavingSharedCustomView: false,
        saveSharedCustomViewError: action.payload,
      };

    // Audit Logs Export - Get All Module Field Action Type Dropdown
    case types.FETCH_RADIOLOGIST_ALL_DDLIST_REQUEST:
      return { ...state, isRadiologistAllDDListLoading: true };
    case types.FETCH_RADIOLOGIST_ALL_DDLIST_SUCCESS:
      return {
        ...state,
        isRadiologistAllDDListLoading: false,
        radiologistAllDDList: action.payload || [],
      };
    case types.FETCH_RADIOLOGIST_ALL_DDLIST_FAILURE:
      return {
        ...state,
        isRadiologistAllDDListLoading: false,
        radiologistAllDDList: [],
      };
    case types.GetAllModuleFieldActionTypeDropdown_REQUEST:
      return { ...state, isModuleFieldActionTypeDropdownLoading: true };
    case types.GetAllModuleFieldActionTypeDropdown_SUCCESS:
      return {
        ...state,
        isModuleFieldActionTypeDropdownLoading: false,
        moduleFieldActionTypeDropdown: action.payload || [],
      };
    case types.GetAllModuleFieldActionTypeDropdown_FAILURE:
      return {
        ...state,
        isModuleFieldActionTypeDropdownLoading: false,
        moduleFieldActionTypeDropdown: [],
      };

    case types.GetAllAuditLogsList_REQUEST:
      return {
        ...state,
        isAuditDetailsLoading: true,
        AuditDetails: action.payload || [],
      };
    case types.GetAllAuditLogsList_SUCCESS:
      return {
        ...state,
        isAuditDetailsLoading: false,
        AuditDetails: action.payload || [],
      };
    case types.GetAllAuditLogsList_FAILURE:
      return { ...state, isAuditDetailsLoading: false, AuditDetails: [] };

    case types.GETALLAUDITLOGCUSTOMREPORT_REQUEST:
      return { ...state, iscustomAuditDetailsLoading: true };
    case types.GETALLAUDITLOGCUSTOMREPORT_SUCCESS:
      return {
        ...state,
        iscustomAuditDetailsLoading: false,
        CustomAuditDetails: action.payload || [],
      };
    case types.GETALLAUDITLOGCUSTOMREPORT_FAILURE:
      return {
        ...state,
        iscustomAuditDetailsLoading: false,
        CustomAuditDetails: [],
      };

    case types.GET_CITY_STATE_BY_ZIPCODE_REQUEST:
      return {
        ...state,
        isZipCodeLoading: true,
      };

    case types.GET_CITY_STATE_BY_ZIPCODE_SUCCESS:
      console.log("API Response in reducer:", action.payload.data); // <-- You can log here too
      return {
        ...state,
        isZipCodeLoading: false,
        zipCodeData: action.payload.data,
        cityName: action.payload.data?.city,
        stateName: action.payload.data?.state,
      };

    case types.GET_CITY_STATE_BY_ZIPCODE_FAILURE:
      return {
        ...state,
        isZipCodeLoading: false,
        zipCodeError: action.payload.error,
      };

    case types.DOWNLOAD_RAD_PROFILE_IMAGE_REQUEST:
      return { ...state, isRadProfileImageDownloading: true };
    case types.DOWNLOAD_RAD_PROFILE_IMAGE_SUCCESS:
      return {
        ...state,
        isRadProfileImageDownloading: false,
        radProfileImageData: action.payload || {},
      };
    case types.DOWNLOAD_RAD_PROFILE_IMAGE_FAILURE:
      return {
        ...state,
        isRadProfileImageDownloading: false,
        radProfileImageData: {},
      };

    case types.DELETE_RAD_PROFILE_IMAGE_REQUEST:
      return {
        ...state,
        isRadProfileImageDeleting: true,
        radProfileImageData: null,
        profileImageName: null,
      };
    case types.DELETE_RAD_PROFILE_IMAGE_SUCCESS:
      return {
        ...state,
        isRadProfileImageDeleting: false,
        radProfileImageDeleteResponse: action.payload || {},
      };
    case types.DELETE_RAD_PROFILE_IMAGE_FAILURE:
      return {
        ...state,
        isRadProfileImageDeleting: false,
        radProfileImageDeleteResponse: {},
      };

    case types.SAVE_RAD_PROFILE_IMAGE_REQUEST:
      return { ...state, isRadProfileImageUploading: true };
    case types.SAVE_RAD_PROFILE_IMAGE_SUCCESS:
      return {
        ...state,
        isRadProfileImageUploading: false,
        radProfileImageData: action.payload || {},
      };
    case types.SAVE_RAD_PROFILE_IMAGE_FAILURE:
      return {
        ...state,
        isRadProfileImageUploading: false,
        radProfileImageData: {},
      };
    case types.GET_RADIOLOGIST_ALL_DD_LIST_REQUEST:
      return { ...state, isRadiologistAllDDListLoading: true };

    case types.GET_RADIOLOGIST_ALL_DD_LIST_SUCCESS:
      return {
        ...state,
        isRadiologistAllDDListLoading: false,
        radiologistAllDDList: action.payload || {},
      };

    case types.GET_RADIOLOGIST_ALL_DD_LIST_FAILURE:
      return {
        ...state,
        isRadiologistAllDDListLoading: false,
        radiologistAllDDList: {},
      };
    case types.SAVE_RAD_CUSTOM_VIEW_REQUEST:
      return {
        ...state,
        isSavingRadCustomView: true,
        saveRadCustomViewSuccess: false,
        saveRadCustomViewError: null,
      };

    case types.SAVE_RAD_CUSTOM_VIEW_SUCCESS:
      return {
        ...state,
        isSavingRadCustomView: false,
        saveRadCustomViewSuccess: true,
        savedRadCustomViewResponse: action.payload,
      };

    case types.SAVE_RAD_CUSTOM_VIEW_FAILURE:
      return {
        ...state,
        isSavingRadCustomView: false,
        saveRadCustomViewSuccess: false,
        saveRadCustomViewError: action.payload,
      };
    case types.SAVE_RAD_CUSTOM_VIEW_RESET:
      return {
        ...state,
        saveRadCustomViewSuccess: false,
      };

    // Clear Associated Site Matrics
    case types.CLEAR_RADPROFILE_ASSOCIATED_SITEMATRICS:
      return { ...state, radProfileAssociatedSiteMatrics: [] };

    // Rate Card - start
    case types.GET_RATE_CARD_DETAILS_BY_RAD_ID_REQUEST:
      return { ...state, isRateCardLoading: true };
    case types.GET_RATE_CARD_DETAILS_BY_RAD_ID_SUCCESS:
      return {
        ...state,
        isRateCardLoading: false,
        rateCardDetails: action.payload || [],
      };
    case types.GET_RATE_CARD_DETAILS_BY_RAD_ID_FAILURE:
      return { ...state, isRateCardLoading: false, rateCardDetails: [] };

    // Rad Document Types
    case types.FETCH_RAD_DOCUMENT_TYPES_REQUEST:
      return { ...state, isRadDocTypesLoading: true };
    case types.FETCH_RAD_DOCUMENT_TYPES_SUCCESS:
      return { ...state, isRadDocTypesLoading: false, radDocumentTypes: action.payload || [] };
    case types.FETCH_RAD_DOCUMENT_TYPES_FAILURE:
      return { ...state, isRadDocTypesLoading: false, radDocumentTypes: [] };

    // Active Home State License Dropdown
    case types.FETCH_ACTIVE_HOME_STATE_LICENSE_DROPDOWN_REQUEST:
      return {
        ...state,
        isActiveHomeStateLicenseDropdownLoading: true,
        activeHomeStateLicenseDropdownError: null,
      };
    case types.FETCH_ACTIVE_HOME_STATE_LICENSE_DROPDOWN_SUCCESS:
      return {
        ...state,
        isActiveHomeStateLicenseDropdownLoading: false,
        activeHomeStateLicenseDropdown: action.payload || [],
      };
    case types.FETCH_ACTIVE_HOME_STATE_LICENSE_DROPDOWN_FAILURE:
      return {
        ...state,
        isActiveHomeStateLicenseDropdownLoading: false,
        activeHomeStateLicenseDropdown: [],
        activeHomeStateLicenseDropdownError: action.payload,
      };

    // Rad Document Management
    case types.FETCH_RAD_DOCUMENTS_REQUEST:
      return { ...state, isRadDocumentsLoading: true };
    case types.FETCH_RAD_DOCUMENTS_SUCCESS:
      return { ...state, isRadDocumentsLoading: false, radDocuments: action.payload || [] };
    case types.FETCH_RAD_DOCUMENTS_FAILURE:
      return { ...state, isRadDocumentsLoading: false, radDocuments: [] };

    case types.UPLOAD_RAD_DOCUMENT_REQUEST:
      return { ...state, isUploadRadDocLoading: true };
    case types.UPLOAD_RAD_DOCUMENT_SUCCESS:
      return { ...state, isUploadRadDocLoading: false };
    case types.UPLOAD_RAD_DOCUMENT_FAILURE:
      return { ...state, isUploadRadDocLoading: false };

    case types.DELETE_RAD_DOCUMENT_REQUEST:
      return { ...state, isDeleteRadDocLoading: true };
    case types.DELETE_RAD_DOCUMENT_SUCCESS:
      return { ...state, isDeleteRadDocLoading: false };
    case types.DELETE_RAD_DOCUMENT_FAILURE:
      return { ...state, isDeleteRadDocLoading: false };

    case types.DOWNLOAD_RAD_DOCUMENT_REQUEST:
      return { ...state, isDownloadRadDocLoading: true };
    case types.DOWNLOAD_RAD_DOCUMENT_SUCCESS:
      return { ...state, isDownloadRadDocLoading: false, radDocumentFile: action.payload };
    case types.DOWNLOAD_RAD_DOCUMENT_FAILURE:
      return { ...state, isDownloadRadDocLoading: false, radDocumentFile: null };

    // Save Rad Note
    case types.SAVE_RAD_NOTE_REQUEST:
      return { ...state, isSaveRadNotesLoading: true };
    case types.SAVE_RAD_NOTE_SUCCESS:
      return { ...state, isSaveRadNotesLoading: false };
    case types.SAVE_RAD_NOTE_FAILURE:
      return { ...state, isSaveRadNotesLoading: false };

    // Save Rad Tags
    case types.SAVE_RAD_TAGS_REQUEST:
      return {
        ...state,
        isSaveRadTagsLoading: true,
        saveRadTagsError: null,
      };
    case types.SAVE_RAD_TAGS_SUCCESS:
      return {
        ...state,
        isSaveRadTagsLoading: false,
        saveRadTagsError: null,
      };
    case types.SAVE_RAD_TAGS_FAILURE:
      return {
        ...state,
        isSaveRadTagsLoading: false,
        saveRadTagsError: action.payload,
      };

    // Rad Note Types Dropdown
    case types.FETCH_RAD_NOTE_TYPES_REQUEST:
      return { ...state, isFetchRadNoteTypesLoading: true };
    case types.FETCH_RAD_NOTE_TYPES_SUCCESS:
      return { ...state, isFetchRadNoteTypesLoading: false, radNoteTypes: action.payload || [] };
    case types.FETCH_RAD_NOTE_TYPES_FAILURE:
      return { ...state, isFetchRadNoteTypesLoading: false, radNoteTypes: [] };

    // License & Privileges Power Sync - start
    case types.FETCH_LICENSE_PRIVILEGES_POWER_SYNC_REQUEST:
      return { ...state, isLicensePrivilegesPowerSyncLoading: true };
    case types.FETCH_LICENSE_PRIVILEGES_POWER_SYNC_SUCCESS:
      return { ...state, isLicensePrivilegesPowerSyncLoading: false, licensePrivilegePowerSync: action.payload || {} };
    case types.FETCH_LICENSE_PRIVILEGES_POWER_SYNC_FAILURE:
      return { ...state, isLicensePrivilegesPowerSyncLoading: false, licensePrivilegePowerSync: {} };

    case types.FETCH_LICENSE_PRIVILEGES_POWER_SYNC_FILTER_OPTIONS_REQUEST:
      return { ...state };
    case types.FETCH_LICENSE_PRIVILEGES_POWER_SYNC_FILTER_OPTIONS_SUCCESS:
      return { ...state, licensePrivilegePowerSyncFilterOptions: action.payload || {} };
    case types.FETCH_LICENSE_PRIVILEGES_POWER_SYNC_FILTER_OPTIONS_FAILURE:
      return { ...state };

    case types.EXPORT_LICENSE_PRIVILEGES_POWER_SYNC_REQUEST:
      return { ...state, isLicensePrivilegesPowerSyncLoading: true };
    case types.EXPORT_LICENSE_PRIVILEGES_POWER_SYNC_SUCCESS:
      return { ...state, isLicensePrivilegesPowerSyncLoading: false };
    case types.EXPORT_LICENSE_PRIVILEGES_POWER_SYNC_FAILURE:
      return { ...state, isLicensePrivilegesPowerSyncLoading: false };
    // License & Privileges Power Sync - end

    default:
      return state;
  }
};

export default radReducer;
